export enum DeprecatedServiceId {
    AtticAndCarpenter = 'atticAndCarpenter',
    BathroomAndSanitaryInstaller = 'bathroomAndSanitaryInstaller',
    BuildingCraftsman = 'buildingCraftsman',
    ChrLayout = 'chrLayout',
    CladdingAndFacade = 'claddingAndFacade',
    CupboardAndStorage = 'cupboardAndStorage',
    CustomFurniture = 'customFurniture',
    CustomizedFittingWardrobeAndLibrary = 'customizedFittingWardrobeAndLibrary',
    DeckPatiosAndVerandas = 'deckPatiosAndVerandas',
    DrivewayPaverAndConcrete = 'drivewayPaverAndConcrete',
    FireplacesAndStove = 'fireplacesAndStove',
    FurnitureAndDecorativeAccessory = 'furnitureAndDecorativeAccessory',
    GardenSupply = 'gardenSupply',
    HomeBuilderAndDeveloper = 'homeBuilderAndDeveloper',
    Ironwork = 'ironwork',
    KitchenDesigner = 'kitchenDesigner',
    LampsAndLight = 'lampsAndLight',
    OfficeLayout = 'officeLayout',
    PoolAndSpaMaintenance = 'poolAndSpaMaintenance',
    SaleAndInstallationOfFenceAndGate = 'saleAndInstallationOfFenceAndGate',
    SpaSeller = 'spaSeller',
    TilingAndFloorCovering = 'tilingAndFloorCovering',
    UpholstererUpholsteryAndCarpet = 'upholstererUpholsteryAndCarpet',
    WindowDoorShutterAndBlind = 'windowDoorShutterAndBlind',
    WineCellarDesignAndLayout = 'wineCellarDesignAndLayout',
    TableAndDesk = 'tableAndDesk',
}

export enum PublishedServiceId {
    Default = 'default',
    ParquetFloor = 'parquetFloor',
    PoolSpaAndSauna = 'poolSpaAndSauna',
    DoorWindowShutterBlind = 'doorWindowShutterBlind',
    FenceAndGate = 'fenceAndGate',
    PergolaVerandaAndShelters = 'pergolaVerandaAndShelters',
    StaircaseAndGuardrail = 'staircaseAndGuardrail',
    InteriorDoorGlassRoofAndPartition = 'interiorDoorGlassRoofAndPartition',
    CustomTerrace = 'customTerrace',
    StorageUnitAndCupboard = 'storageUnitAndCupboard',
    Table = 'table',
    DeskAndMeetingTable = 'deskAndMeetingTable',
    Seated = 'seated',
    BedroomAndBedding = 'bedroomAndBedding',
    FrontDoorAndService = 'frontDoorAndService',
    Kitchen = 'kitchen',
    StoneAndWorktop = 'stoneAndWorktop',
    DecorationAndLighting = 'decorationAndLighting',
    MirroringAndGlazing = 'mirroringAndGlazing',
    ShopLayout = 'shopLayout',
    LayoutAndFurnitureCofeeHotelAndRestaurant = 'layoutAndFurnitureCofeeHotelAndRestaurant',
    WorkspaceLayoutAndFurniture = 'workspaceLayoutAndFurniture',
    InteriorAndOutdoorLayoutAndFurniture = 'interiorAndOutdoorLayoutAndFurniture',
    CounterBar = 'counterBar',
    ConsoleAndDressingTable = 'consoleAndDressingTable',
}

export type ServiceId = DeprecatedServiceId | PublishedServiceId;

export default ServiceId;
